module.exports = __webpack_public_path__ + "static/pivitol-13c5ab80474d26bc2274593305509baa.svg";